<mat-card *ngIf="editClientSociData" style="height:100%">
 <form #loginForm="ngForm">
    <mat-toolbar style="width:100%">
      <div style="width:100%;float:right">
        <button mat-icon-button style="float: right; matInput margin-right: 0" mat-icon-button (click)="deleteClientSoci(editClientSociData.id)" matTooltip="{{'clientsSocis.esborrarToolTip' | translate}}" aria-label="{{'clientsSocis.esborrarToolTip' | translate}}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">delete</mat-icon>
        </button>
        <button mat-icon-button style="float: right; matInput margin-right: 0" mat-icon-button (click)="addOrUpdate()" matTooltip="{{'clientsSocis.desarToolTip' | translate}}" aria-label="{{'clientsSocis.desarToolTip' | translate}}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">save</mat-icon>
        </button>
      </div>
    </mat-toolbar>
    <mat-progress-bar mode="indeterminate" color="warm" *ngIf="showAsyncProgress"></mat-progress-bar>
    <mat-card-content style="float:left;clear:both;padding: 24px;">
      <h2 mat-line style="width:70%;color: black">Dades dels clients i socis</h2>
      <div style="float:left;clear:both;margin-top:0px;width:100%">
      <mat-form-field style="width: 50%;padding-top:5px">
       <input matInput placeholder="Nom/Sigles" name="nom" [(ngModel)]="editClientSociData.nom" ngDefaultControl />
      </mat-form-field>
      <mat-select style="width:37%;padding-left:20px" [(ngModel)]="editClientSociData.tipus" [ngModelOptions]="{standalone: true}" placeholder="Tipus">
        <mat-option *ngFor="let tipus of possibleTipus" [value]="tipus" selected="tipus === editClientSociData.tipus ? 'true' : 'false'">{{tipus}}</mat-option>
      </mat-select>
      <mat-form-field style="width: 50%;padding-left:20px">
       <input matInput placeholder="Adreça" name="adreca"
        [(ngModel)]="editClientSociData.adreca" ngDefaultControl/>
      </mat-form-field>
      <mat-form-field style="width: 37%;padding-left:20px">
       <input matInput placeholder="Localització" name="localitzacio"
        [(ngModel)]="editClientSociData.localitzacio" ngDefaultControl/>
      </mat-form-field>
      <mat-form-field style="width: 25%;padding-left:20px">
       <input matInput placeholder="País" name="country"
        [(ngModel)]="editClientSociData.country" ngDefaultControl/>
      </mat-form-field>
      <mat-form-field style="width: 11%;padding-left:20px">
       <input matInput placeholder="CIF" name="cif"
        [(ngModel)]="editClientSociData.cif" ngDefaultControl/>
      </mat-form-field>
      <mat-form-field style="width: 10%;padding-left:20px">
       <input matInput placeholder="Telèfon" name="telefon"
        [(ngModel)]="editClientSociData.telefon" ngDefaultControl/>
      </mat-form-field>
      <mat-form-field style="width: 20%;padding-left:20px">
       <input matInput placeholder="E-correu" name="mail"
        [(ngModel)]="editClientSociData.mail" ngDefaultControl/>
      </mat-form-field>
      <mat-form-field style="width: 15%;padding-left:20px">
       <input matInput placeholder="Web" name="web"
        [(ngModel)]="editClientSociData.web" ngDefaultControl/>
      </mat-form-field>
      </div>
      <div style="float:left;clear:both;margin-top:0px;width:90%">
        <mat-form-field style="width: 100%;padding-left:20px">
          <textarea matInput placeholder="Nom legal" name="descripcio" rows="3" [(ngModel)]="editClientSociData.descripcio"  style="width: 100%">
          </textarea>
        </mat-form-field> 
      </div>
      <div style="float:left;clear:both;margin-top:0px;width:90%">
        <mat-form-field style="width: 100%;padding-left:20px">
          <textarea matInput placeholder="Comentaris" name="comentari" rows="3" [(ngModel)]="editClientSociData.comentari"  style="width: 100%">
          </textarea>
        </mat-form-field> 
      </div>
      <div style="float:left;clear:both;margin-top:0px;width:90%">
        <mat-checkbox style="margin-right: 1em;"  name="client" [(ngModel)]="editClientSociData.client">Client</mat-checkbox>
        <mat-checkbox style="margin-right: 1em;"  name="soci" [(ngModel)]="editClientSociData.soci">Soci</mat-checkbox>
      </div>
      <div style="float:left;clear:both;margin-top:0px;width:90%;padding-left:20px" *ngIf="error !== ''">
        <span style="color:red;font-weight: bold">{{error}}</span>
      </div>
    </mat-card-content>
  </form>
</mat-card>
